import { ClearUser } from "../../Redux/UserSlice/userSlice";
import { sendPostCallToSever } from "../Axios/Axios";
import { auth } from "../../Config/firebase-config";
import { ClearAuth } from "../../Redux/AuthSlice/authSlice";
import { ClearImage } from "../../Redux/MainImage/imageSlice";
import { deleteAll } from "../../Redux/WaterMarks/watermarks";
import { signOut } from "firebase/auth";
import type { AppDispatch } from "../../Redux/store";

const LoginAPI = () => (dispatch: AppDispatch) => {
  return sendPostCallToSever({}, "users/login")
    .then(async (result) => {
      const data = result.data;
      if (data) {
        // Force Firebase to pick up any new custom claims set by the server
        await RefreshToken();
        return data;
      } else return false;
    })
    .catch((error) => {
      // Backend errors (network, 4xx/5xx) should not throw to the caller.
      // Return false so signIn.tsx can show a friendly message without
      // triggering Logout() (the Firebase session may still be valid).
      console.error("LoginAPI error:", error);
      return false;
    });
};

const RefreshToken = (): Promise<string | undefined> => {
  const user = auth.currentUser;
  if (!user) return Promise.resolve(undefined);
  return user
    .getIdTokenResult(true)
    .then((idTokenResult) => {
      const refreshedToken = idTokenResult.token;
      return refreshedToken;
    })
    .catch((error) => {
      console.log("refreshed error", error);
      return undefined;
    });
};

const Logout = () => (dispatch: AppDispatch) => {
  signOut(auth);
  dispatch(ClearImage());
  dispatch(deleteAll());
  dispatch(ClearUser());
  dispatch(ClearAuth());
};

export { LoginAPI, RefreshToken, Logout };
